import React, { useContext } from "react";
import GlobalContext from "contexts/GlobalContext";
import AlreadyHaveSiaIdPage from "./Pages/AlreadyHaveSiaIdPage";
import AlreadyRegisteredPage from "./Pages/AlreadyRegisteredPage";
import RegistrationOptionsPage from "./Pages/RegistrationOptions/RegistrationOptionsPage";

const WizardPage = () => {
  const { user } = useContext(GlobalContext);

  const renderPageAccordingToUserType = () => {
    if (!user) {
      return <AlreadyHaveSiaIdPage />;
    } else {
      const ROLE_SINGLE = "sia_role_single";
      const userRole = user.getRole();
      if (userRole === ROLE_SINGLE) {
        return <RegistrationOptionsPage />;
      } else {
        return <AlreadyRegisteredPage />;
      }
    }
  };

  const currentPage = renderPageAccordingToUserType();
  return currentPage;
};

export default WizardPage;
